import {useQuery} from '@tanstack/react-query';
import {QUERY_KEYS} from 'infra/libs/react-query/queryKeys';
import {getWomenChannelUrl} from 'presentation/pages/private/help/services/getWomenChannelUrl';

const useGetWomenChannelUrlQuery = () =>
	useQuery({
		queryKey: [QUERY_KEYS.WOMEN_CHANNEL_URL],
		queryFn: ({signal}) => getWomenChannelUrl({signal}),
		enabled: false,
	});

export {useGetWomenChannelUrlQuery};
